export const DigitalTwinPageModalities = {
  EMPTY: "empty",
  CREATION: "creation",
  SELECTION: "selection",
  SELECTED: "selected",
  COMPARE: "compare",
  EDIT: "edit",
};

export const DigitalTwinDisplayTypes = {
  TWIN: "twin",
  GRID: "grid",
};
